import {Action} from './action';
import {ComposedPumpFunQuick, DEFAULT_COMPOSED_PUMP_FUN_QUICK} from './compose';
import {Condition} from './condition';

export * from './action';
export * from './compare';
export * from './compose';
export * from './condition';
export * from './field';
export * from './operator';
export * from './time';
export * from './value';
export * from './venue';

export enum RuleStatus {
    ACTIVE = 'ACTIVE',
    INACTIVE = 'INACTIVE',
    ACTIVE_EXHAUSTED = 'ACTIVE_EXHAUSTED',
    INACTIVE_EXHAUSTED = 'INACTIVE_EXHAUSTED'
}

export enum RuleType {
    PUMP_FUN = "PUMP_FUN",
    PUMP_FUN_MANAGED = "PUMP_FUN_MANAGED",
    PUMP_SWAP = "PUMP_SWAP",
    PUMP_SWAP_MANAGED = "PUMP_SWAP_MANAGED",
    PUMP_UP = "PUMP_UP",
    PUMP_UP_MANAGED = "PUMP_UP_MANAGED",
    JUPITER = "JUPITER",
    JUPITER_MANAGED = "JUPITER_MANAGED",
}

export const isManagedRule = (type: RuleType): boolean => {
    switch (type) {
        case RuleType.PUMP_FUN:
            return false;
        case RuleType.PUMP_FUN_MANAGED:
            return true;
        case RuleType.PUMP_SWAP:
            return false;
        case RuleType.PUMP_SWAP_MANAGED:
            return true;
        case RuleType.PUMP_UP:
            return false;
        case RuleType.PUMP_UP_MANAGED:
            return true;
        case RuleType.JUPITER:
            return false;
        case RuleType.JUPITER_MANAGED:
            return true;
    }
}

export type Sequence = {
    condition: Condition,
    action: Action
}


export const DEFAULT_CONDITION: ComposedPumpFunQuick = {...DEFAULT_COMPOSED_PUMP_FUN_QUICK};